export * from "./megafair-brand.component";
